import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { getAppName } from '@mode/shared/util-js';

@Component({
  selector: 'mode-seat-limit',
  templateUrl: './seat-limit.component.html',
  styleUrls: ['./seat-limit.component.scss'],
})
export class SeatLimitComponent implements OnInit {
  readonly appName = getAppName({ isFree: true });
  homeUrl = '/home/';
  escapedHtml = "But don't worry, there are options! Chat with a Mode <br />representative to discuss next steps.";
  errorTitle!: string;
  errorExplanation!: SafeHtml;
  errorInstructions!: string;
  errorPrimaryActionLabel!: string;
  errorSecondaryActionLabel!: string;
  errorSecondaryActionTarget!: string;
  numberOfSeats = 3;
  planTitle = '';

  @Input()
  hasNoSecondary!: boolean;

  @Input()
  paidPlan!: boolean;

  @Input()
  dbPage = false;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit() {
    this.errorTitle = this.title();
    this.errorPrimaryActionLabel = this.primaryActionLabel();
    this.errorSecondaryActionLabel = this.secondaryActionLabel();
    this.errorSecondaryActionTarget = this.secondaryActionTarget();
    this.errorExplanation = this.explanation();
    this.errorInstructions = this.instructions();
  }

  title(): string {
    if (this.dbPage && !this.paidPlan) return `You've reached your ${this.numberOfSeats}-seat limit`;
    return this.paidPlan
      ? 'Your workspace has reached the maximum number of users.'
      : `You've hit your ${this.numberOfSeats}-seat limit for ${this.appName}`;
  }

  explanation(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.escapedHtml);
  }

  instructions(): string {
    if (this.dbPage)
      return `Need to invite teammates with database credentials? No problem! Upgrade to bring the rest of your team on board.`;

    return `Upgrade today for seat options tailored to your team`;
  }

  primaryActionLabel(): string {
    return this.paidPlan || this.dbPage ? `Upgrade now` : `Book a Call`;
  }

  secondaryActionLabel(): string {
    return this.paidPlan ? `Back to My Work` : `Back to ${this.appName}`;
  }

  secondaryActionTarget(): string {
    return this.homeUrl;
  }
}
